
export const formatIsoDateString = (isoString: string): string => {
  if (!isoString) return '';

  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // 判斷是上午或下午
  const period = hours >= 12 ? '下午' : '上午';

  return `${year}/${month}/${day} ${period}${hours}:${minutes}`;
};

export const timestampToDate = (ts) => {
  if (!ts || typeof ts._seconds === 'undefined') return null;
  return new Date(ts._seconds * 1000 + Math.floor(ts._nanoseconds / 1000000));
}